import { useState,useEffect } from 'react';
import Kdptecsidebar from '../Components/Kdptecsidebar';
import Kdptecnavbar from '../Components/Kdptecnavbar';
import {Link} from 'react-router-dom'
import TecLeadersMain from '../Components/TecLeadersMain';

const TecLeaders = () => {

    const[sidebar,setSidebarOpen]= useState(false);

    const togglesidebar =()=> {
      setSidebarOpen((prevState) => !prevState)
    }
    
    const toggleLogout =()=>{

      document.getElementById("modalLogoutForm").style.display = "block";
     }

    function removelocalstorage(){
        
      localStorage.clear();
      window.location.href='/'
  
}

   function closeForm()
   {
      document.getElementById("modalLogoutForm").style.display = "none";
    
    }
    useEffect(()=>{
      
      let venture = localStorage.getItem('ventureid');
      let Teccheck = venture.includes('06')
      console.log(Teccheck)
    if(Teccheck==true){document.getElementById("TEC-dashboard").style.display="grid"}
    else{ document.getElementById("TEC-dashboard").style.display="none"}
   },[]);
  
  return (
    <div className="tec-container" id="TEC-dashboard">
    <Kdptecnavbar sidebar={sidebar} openSidebar={togglesidebar}/>
   <Kdptecsidebar sidebar={sidebar} openLogForm={toggleLogout} />
   <TecLeadersMain />

   <div className="tec-pop-fade" id="modalLogoutForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">LOG OUT</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to logout?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
        <Link to="/"><button className="tec-adduser-button" onClick={removelocalstorage} type='submit'>Confirm</button></Link>
        <button className="tec-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>
 </div>
  )
}

export default TecLeaders
